export default __webpack_public_path__ + "static/media/login_bg_left.50ab1a05.svg";